module.exports = __webpack_public_path__ + "static/media/coffee-work.5d772132.svg";